import CryptoUtils from "../../util/cryptoUtils";
import { Globals as OldGlobals} from "../../global/Globals";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

export const mapResponseToFormFields = (responseData, Globals) => {
  
    return [
      {
        title: "Proposal Title",
        type: "input",
        inputValue: responseData?.projectTitle||'',
        maxChar: 1024,
        isRequired: true,
        isInfo: false,  
        key: 'projectTitle',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.PROPOSALTITLE,
        placeHolderValue:"Eg.Breaking Bad"
      },
      {
        title: "Logline",
        type: "textarea",
        inputValue: responseData?.logLine ||'',
        maxChar: 1000,
        isRequired: true,
        isInfo: true,
        key: 'logLine',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.LOGLINE,
        placeHolderValue:"Eg. In a galaxy far, far away",
        infoMessage:Globals.UNSOLICITED_TOOLTIP_LOGLINE
      },
      {
        title: "Synopsis",
        type: "textarea",
        inputValue: responseData?.synopsis||'',
        maxChar: 2500,
        isRequired: true,
        isInfo: true,
        key: 'synopsis',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.SYNOPSIS,
        infoMessage:Globals.UNSOLICITED_TOOLTIP_SYNOPSIS,
        placeHolderValue:"Eg. In a galaxy far, far away"
      },
      
      {
        title: "Episode Structure and Outline",
        type: "textarea",
        inputValue: responseData?.episodeStructure ||'',
        maxChar: 2500,
        isRequired: true,
        isInfo: true,
        key: 'episodeStructure',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.EPISODESTRUCTUREOUTLINE,
        placeHolderValue:"Eg. 2 Seasons, 15 episodes ",
        infoMessage:Globals.UNSOLICITED_TOOLTIP_EPISODE_ST_OUTLINE
      },
      {
        title: "Editorial Details",
        type: "textarea",
        inputValue: responseData?.editorialDetails ||'',
        maxChar: 2500,
        isRequired: true,
        isInfo: false,
        key: 'editorialDetails',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.EDITORIALDETAILS,
        placeHolderValue:"Eg. Genre, Target Audience "
      },
      {
        title: "Lookbook and Moodboard ( .pdf or .doc or .ppt )",
        type: "file",
        inputValue: responseData?.documents?.[0] ||'',
        maxChar: 1024,
        isInfo: false,
        key: "lookbookAndMoodboard",
        errorMessage:Globals.LOOKBOOK_ERROR,
        supportedFileType:'lookbookpdfOrDocOnly',
        fileKey:"LBMB"
      },
      {
        title: "",
        type: "group",
        items: [
          {
            title: "Currency",
            type: "dropdown",
            inputValue: responseData?.currencyId ||'',
            maxChar: 1024,
            isRequired: true,
            isInfo: false,
            key: 'currencyId',
            errorMessage:Globals.UNSOLICITED_ERROR_MSG.CURRENCY,
            placeHolderValue:"Eg. ZAR"
          },
          {
            title: "Preliminary Budget",
            type: "input",
            inputValue: responseData?.targetBudget ||'',
            maxChar: 1024,
            isRequired: true,
            isInfo: false,
            key: 'targetBudget',
            errorMessage:Globals.UNSOLICITED_ERROR_MSG.PRELIMINARYBUDGET,
            placeHolderValue:"Eg. 100,000"
          },
        ],
      },
      {
        title: "Pitch Deck ( .pdf or .doc or .ppt )",
        type: "file",
        inputValue: responseData?.documents?.[1] ||'',
        maxChar: 1024,
        isInfo: false,
        key: "productionSchedule",
        errorMessage:'Please enter production schedule',
        supportedFileType:'productionpdfOrDocOnly',
        fileKey:"PRSCH"
      },
      {
        title: "Location and Studio Information",
        type: "textarea",
        inputValue: responseData?.locationStudioInfo ||'',
        maxChar: 1000,
        isRequired: false,
        isInfo: false,
        key:"locationStudioInfo",
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.LOCATIONSTUDIOINFO,
        placeHolderValue:"Eg. Cities, Locations and Addresses"
      },
      {
        title: "Cast and Presenter Information",
        type: "textarea",
        inputValue: responseData?.castPresenterInfo ||'',
        maxChar: 1000,
        isInfo: false,
        key: 'castPresenterInfo',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.CASTPRESENTERINFO,
        placeHolderValue:"Eg. Brad Pitt etc."
      },
      {
        title: "Brand Integration Opportunities",
        type: "textarea",
        inputValue: responseData?.brandIntegration ||'',
        maxChar: 1000,
        isInfo: true,
        key: 'brandIntegration',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.BRANDINTEGRATIONOPPORTUNITIES,
        placeHolderValue:"Eg. Adidas, Pepsi, Gucci",
        infoMessage:Globals.UNSOLICITED_TOOLTIP_BRAND_INTEGRATION,
        isRequired:responseData?.productionTypeName===Globals.APPLY_BRIEF.ADVERSTISER_FUNDED?true:CryptoUtils.getFromLocalStorage("prodTypeName")===Globals.APPLY_BRIEF.ADVERSTISER_FUNDED?true:false
      },
      {
        title: "Company Profile and Team Details",
        type: "textarea",
        inputValue: responseData?.keyTeams ||'',
        maxChar: 1000,
        isRequired: true,
        isInfo: true,
        key: 'keyTeams',
        errorMessage:Globals.UNSOLICITED_ERROR_MSG.CMPPROFILEANDTEAMDETAILS,
        placeHolderValue:"Eg. Director, D.O.P etc.",
        infoMessage:Globals.TOOLTIP_COMPANY
      }
    ];
  };

  // postData.js
export const postData = (info,formValues, status = 0,getAllData,files,initialData) => {
  return {
    proposalId: info?.proposalId || formValues?.proposalId,
    proposalDetailId: formValues?.proposalDetailId || getAllData?.proposalDetailId || 0,
    // producerId: "0efd507f-04ec-48a8-a92b-9d7dd8eedceb",
    logLine: formValues?.logLine || '',
    synopsis: formValues?.synopsis || '',
    // proposalTitle: formValues?.proposalTitle || '',
    editorialDetails: formValues?.editorialDetails|| '',
    currencyId:formValues?.currencyId||0,
    noOfEpisodes: 1,
    episodeDuration: 120,
    targetAudienceId: 5,
    episodeStructure: formValues?.episodeStructure || '',
    castPresenterInfo: formValues?.castPresenterInfo || '',
    locationStudioInfo: formValues?.locationStudioInfo || '',
    brandIntegration: formValues?.brandIntegration || '',
    keyTeams: formValues?.keyTeams || '',
    productionTimeLine: "NA",
    artistName: "NA",
    projectTitle: formValues?.projectTitle || '',
    songName: "NA",
    targetBudget: formValues?.targetBudget || '',
    // currencyId: formValues?.currencyIndex,
    status: status,
    projectStatus: "NA",
    referenceLinks: "NA",
    submissionDate: "NA",
    // createdBy: "0271834e-dc26-47c0-99af-943a8e39a1ac",
    // updatedBy: "0271834e-dc26-47c0-99af-943a8e39a1ac",
    propRefNo: info?.bRefNo || getAllData?.[0]?.propRefNo || '',
    documents: [
      {
        documentFor: "LBMB",
        documentId: files?.lookBoardMoodBaord1?.documentId || 1,
        documentName:files?.lookBoardMoodBaord1?.name,
        documentPath:files?.lookBoardMoodBaord1?.path,
        documentType:files?.lookBoardMoodBaord1?.type,
        uploadedAt:  files?.lookBoardMoodBaord1?.uploadedAt|| new Date().toISOString(),
        
        
      },
      {
        documentFor: "PRSCH",
        documentId:files?.productionSchedule1?.documentId||2,
        documentName:files?.productionSchedule1?.name,
        documentPath:files?.productionSchedule1?.path,
        documentType:files?.productionSchedule1?.type,
        uploadedAt:files?.productionSchedule1?.uploadedAt ||  new Date().toISOString(),
        
      },
      {
        documentFor: "SHWRL",
        documentId: files?.reel?.documentId||3,
        documentName: files?.reel?.name,
        documentType: files?.reel?.path,
        documentType: files?.reel?.type,
        uploadedAt:files?.reel?.uploadedAt|| new Date().toISOString(),
        
      },
      {
        documentFor: "CPRC",
        documentId: files?.cer?.documentId||4,
        documentName: files?.cer?.name,
        documentPath:files?.cer?.path,
        documentType:files?.cer?.type,
        uploadedAt:files?.cer?.uploadedAt|| new Date().toISOString(),
        
      },
      {
        documentFor: "RDOC",
        documentId: files?.reg?.documentId||5,
        documentName:files?.reg?.name,
        documentPath:files?.reg?.path,
        documentType:files?.reg?.type,
        uploadedAt:files?.reg?.uploadedAt|| new Date().toISOString(),
       
      },
    ],
    // Conditionally include file-related fields only if `path` exists
    ...(!files?.productionSchedule1?.path && { productionSchedule: files?.productionSchedule1 }),
    ...(!files?.lookBoardMoodBaord1?.path && { lookBoardMoodBaord: files?.lookBoardMoodBaord1 }),
    ...(!files?.reel?.path && { showReel: files?.reel }),
    ...(!files?.cer?.path && { certCopyRightRegistration: files?.cer }),
    ...(!files?.reg?.path && { regulatoryDocument: files?.reg }),
  };
};

